import manufactureImg from "../assets/manufacture.png"; // Replace with your actual image path
import { motion } from "framer-motion";
import factoryImage from "../assets/factory-image.png"; // Replace with actual image name
import patternBg from "../assets/pattern-bg.png";
import circleBg from "../assets/circle-bg.svg"; // your uploaded background circle image
import iconAutomationBlue from "../assets/icon-automation-blue.png";
import iconAutomationWhite from "../assets/icon-automation-white.png";
import iconTestingBlue from "../assets/icon-testing-blue.png";
import iconTestingWhite from "../assets/icon-testing-white.png";
import globeImg from "../assets/global-standards.png";
import smartFactoryImg from "../assets/smart-manufacturing.png";
import chartImg from "../assets/speed-scale.png";
import handImage from "../assets/hand-tray.png";
import dot from "../assets/dot.svg"; 
import connectorLine from "../assets/line-connector.svg"; // your new uploaded SVG



const ManufactureHero = () => {
  const Card = ({ title }) => (
  <div className="bg-white rounded-2xl shadow-md px-6 py-6 text-center w-[270px]">
    <h3 className="text-xl font-semibold text-gray-900">{title}</h3>
    <p className="text-sm text-gray-600 mt-2">
      We follow internationally recognized quality and safety standards to ensure
      consistent, world-class output.
    </p>
  </div>
);

const industries = [
  { title: "Automotive" },
  { title: "Aerospace" },
  { title: "Electronics", isCenter: true },
  { title: "Consumer Goods" },
  { title: "Medical Devices" },
];

     return (
<>
 <section className="w-full bg-[#FFF0EF] py-20 px-4 sm:px-6">
  <div className="w-full max-w-[1312px] mx-auto flex flex-col lg:flex-row items-center justify-between gap-10">
    
    {/* Left Column – 60% with animation */}
    <motion.div
      className="w-full lg:w-[60%]"
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.8, ease: "easeOut" }}
    >
      <h5 className="text-[#212129] text-sm font-medium uppercase mb-3 tracking-wide">
        Manufacturing
      </h5>

      <h2 className="text-[#1E1E1E] text-[40px] md:text-[48px] font-extrabold leading-tight mb-6">
           Making products using <br /> 
           machines and labor.
      </h2>

      <p className="text-[#4A4A4A] text-base leading-relaxed max-w-[580px]">
         Manufacturing is the process of converting raw materials into finished   <br/> goods using machinery, tools, and labor.

      </p>
    </motion.div>

    {/* Right Column – 40% with animation */}
    <motion.div
      className="w-full lg:w-[40%] flex justify-center"
      initial={{ opacity: 0, x: 60 }}
      whileInView={{ opacity: 1, x: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.8, delay: 0.2, ease: "easeOut" }}
    >
      
    <img
    src={manufactureImg}
    alt="Manufacture Illustration"
    className="w-3/4 max-w-[400px] object-contain"
  />
    </motion.div>

  </div>
</section>
 <section className="w-full flex justify-center px-7 md:px-8 lg:px-8 py-12">
      {/* Card Container with fixed width & rounded corners */}
      <div
        className="w-[1412px] rounded-[48px] overflow-hidden px-10 md:px-16 py-14 flex flex-col lg:flex-row items-center justify-between gap-10"
        style={{
          
          backgroundColor: "#212129",
        backgroundImage: `url(${patternBg})`, // fallback
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        {/* Left Image */}
        <div className="w-full lg:w-[50%] flex justify-center">
          <img
            src={factoryImage}
            alt="Factory"
            className="max-w-full h-auto"
          />
        </div>

        {/* Right Content */}
        <div className="w-full lg:w-[50%] text-white">
          <div className="bg-[#3F3F3F] inline-block text-sm font-medium px-5 py-2 rounded-full mb-4">
            Let’s build something great together
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4 leading-tight">
            Empowering industry<br />through excellence
          </h2>
          <p className="text-base sm:text-lg text-[#D4D4D4] max-w-xl">
            We are a technology-led manufacturing company focused on delivering
            reliable, efficient, and customized production solutions. With a
            commitment to innovation and quality, we help businesses scale with
            confidence.
          </p>
        </div>
      </div>
    </section>
   <section className="bg-[#FAFAFA]">
      <div className="bg-white rounded-t-[48px] px-4 md:px-12 lg:px-20 py-20 relative overflow-hidden">
        <div className="max-w-screen-xl mx-auto flex flex-col lg:flex-row justify-between items-center gap-12 relative">
          {/* Left Content */}
          <div className="max-w-xl text-center lg:text-left z-10">
            <div className="inline-block px-6 py-2 rounded-full bg-[#EDEDED] text-[#1A1A1A] text-sm font-medium mb-6">
              KNOW ABOUT US
            </div>
            <h2 className="text-[36px] sm:text-[44px] font-bold text-[#1A1A1A] mb-4 leading-tight">
              What We Do
            </h2>
            <p className="text-[#3F3F3F] text-lg leading-relaxed">
              We handle everything from design and prototyping to production,
              assembly, and global delivery—ensuring a smooth, end-to-end manufacturing process.
            </p>
          </div>

          {/* Right Cards Section */}
          <div className="relative w-full max-w-[480px] h-[480px] sm:h-[440px] z-10 mx-auto">
            {/* Background Circle Image */}
            <img
              src={circleBg}
              alt="Circle Background"
              className="absolute w-[200px] h-[200px] left-[calc(50%-100px)] top-[120px] animate-spin-slow opacity-60 z-0"
            />

            {/* Top Left Card */}
            <div className="absolute left-5 top-[20px] w-[48%] sm:w-[214.6px] h-[46%] sm:h-[201.19px] rounded-[24px] bg-gradient-to-b from-[#00994C] to-[#005F2F] text-white shadow-md flex flex-col items-center justify-center p-6 z-10">
              <img src={iconAutomationWhite} alt="Automation White" className="w-8 h-8 mb-4" />
              <h4 className="text-center font-semibold text-base">Industrial Automation</h4>
            </div>

            {/* Top Right Card */}
            <div className="absolute right-0 top-0   w-[48%] sm:w-[214.6px] h-[46%] sm:h-[201.19px] rounded-[24px] bg-white text-[#0052CC] shadow-md flex flex-col items-center justify-center p-6 z-10">
              <img src={iconTestingBlue} alt="Testing Blue" className="w-8 h-8 mb-4" />
              <h4 className="text-center font-semibold text-base leading-snug">
                Assembly &<br />Quality Testing
              </h4>
            </div>
            {/* Bottom Left Card */}
            <div className="absolute left-[5%] bottom-[-10px] w-[48%] sm:w-[214.6px] h-[46%] sm:h-[201.19px] rounded-[24px] bg-white text-[#0052CC] shadow-md flex flex-col items-center justify-center p-6 z-10">
              <img src={iconAutomationBlue} alt="Automation Blue" className="w-8 h-8 mb-4" />
              <h4 className="text-center font-semibold text-base">Industrial Automation</h4>
            </div>

            {/* Bottom Right Card */}
            <div className="absolute right-[0%] top-[230px] sm:bottom-[-20px] w-[48%] sm:w-[214.6px] h-[46%] sm:h-[201.19px] rounded-[24px] bg-gradient-to-b from-[#00994C] to-[#005F2F] text-white shadow-md flex flex-col items-center justify-center p-6 z-10">
              <img src={iconTestingWhite} alt="Testing White" className="w-8 h-8 mb-4" />
              <h4 className="text-center font-semibold text-base leading-snug">
                Assembly &<br />Quality Testing
              </h4>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section className="bg-white py-20 px-6 md:px-10 lg:px-16">
      <div className="max-w-7xl mx-auto text-center">
        {/* Tagline */}
        <span className="inline-block bg-gray-200 text-gray-800 text-xs font-semibold px-4 py-1 rounded-full uppercase tracking-wide mb-4">
          Why Choose Us
        </span>

        {/* Heading */}
        <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 mb-4">
          Our capabilities
        </h2>

        {/* Description */}
        <p className="text-lg text-gray-600 max-w-2xl mx-auto mb-16 leading-relaxed">
          We deliver reliable, high-quality manufacturing with advanced technology, expert teams, and a strong focus on precision, innovation, and on-time delivery.
        </p>

        {/* 3-Card Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {/* Card 1 */}
          <div className="bg-gray-50 rounded-2xl shadow-md px-6 py-8 flex flex-col items-center text-center h-full">
            <h3 className="text-lg md:text-xl font-semibold text-gray-900 mb-2">
              Global Standards
            </h3>
            <p className="text-sm md:text-base text-gray-600 mb-6 leading-relaxed max-w-xs">
              We follow internationally recognized quality and safety standards to ensure consistent, world-class output.
            </p>
            <img
              src={globeImg}
              alt="Global Standards"
              className="w-[350px] h-[350px] object-contain"
            />
          </div>

          {/* Card 2 */}
          <div className="bg-gray-50 rounded-2xl shadow-md px-6 py-8 flex flex-col items-center text-center h-full">
            <h3 className="text-lg md:text-xl font-semibold text-gray-900 mb-2">
              Smart Manufacturing
            </h3>
            <p className="text-sm md:text-base text-gray-600 mb-6 leading-relaxed max-w-xs">
              Our facilities integrate automation, IoT, and data-driven systems for efficient, intelligent production.
            </p>
            <img
              src={smartFactoryImg}
              alt="Smart Manufacturing"
              className="w-[350px] h-[350px] object-contain"
            />
          </div>

          {/* Card 3 */}
          <div className="bg-gray-50 rounded-2xl shadow-md px-6 py-8 flex flex-col items-center text-center h-full">
            <h3 className="text-lg md:text-xl font-semibold text-gray-900 mb-2">
              Speed & Scale
            </h3>
            <p className="text-sm md:text-base text-gray-600 mb-6 leading-relaxed max-w-xs">
              We deliver high-volume manufacturing with rapid turnaround times—without compromising quality.
            </p>
            <img
              src={chartImg}
              alt="Speed and Scale"
              className="w-[350px] h-[350px] object-contain"
            />
          </div>
        </div>
      </div>
    </section>
      <section className="bg-[#FFF9EF] py-16 px-4 font-[Poppins] relative overflow-hidden">
      <div className="max-w-7xl mx-auto text-center relative">
        {/* Header */}
        <h2 className="text-3xl md:text-5xl font-extrabold text-gray-900">
          Industries We Serve
        </h2>
        <p className="mt-4 text-base md:text-lg text-gray-600 max-w-2xl mx-auto">
          We cater to a diverse range of industries with tailored manufacturing
          solutions that meet specific standards, regulations, and performance needs.
        </p>

        {/* Connector SVG as Background */}
        <img
          src={connectorLine}
          alt="connector-line"
          className="absolute hidden md:block top-[260px] left-1/2 -translate-x-1/2 z-0 w-[900px] max-w-[90vw]"
        />

        {/* Grid Layout */}
        <div className="mt-20 grid grid-cols-1 md:grid-cols-3 gap-14 items-start relative z-10">
          {/* Left Column */}
          <div className="flex flex-col gap-14 items-center md:items-end">
            <Card title="Automotive" />
            <Card title="Consumer Goods" />
          </div>

          {/* Center Column */}
          <div className="flex flex-col items-center justify-start">
            <Card title="Electronics" />
            <img
              src={handImage}
              alt="hand"
              className="w-[150px] md:w-[180px] mt-8 object-contain z-10"
            />
          </div>

          {/* Right Column */}
          <div className="flex flex-col gap-14 items-center md:items-start">
            <Card title="Aerospace" />
            <Card title="Healthcare & Medical Devices" />
          </div>
        </div>
      </div>
    </section>
    <section className="bg-[#FFF9EF] py-20 px-4 font-[Poppins] relative overflow-hidden">
      <div className="max-w-7xl mx-auto text-center relative">
        {/* Header */}
        <h2 className="text-3xl md:text-5xl font-extrabold text-gray-900">
          Industries We Serve
        </h2>
        <p className="mt-4 text-base md:text-lg text-gray-600 max-w-2xl mx-auto">
          We cater to a diverse range of industries with tailored manufacturing
          solutions that meet specific standards, regulations, and performance needs.
        </p>

        {/* Connector SVG Background */}
        <img
          src={connectorLine}
          alt="connector-line"
          className="absolute hidden md:block top-[300px] left-1/2 -translate-x-1/2 z-0 w-[900px] max-w-[90vw]"
        />

        {/* Dots (5 total) – based on screenshot */}
        {/* Top Left */}
        <img
          src={dot}
          alt="dot"
          className="absolute hidden md:block top-[320px] left-[15%] w-4 h-4 z-10"
        />
        {/* Top Right */}
        <img
          src={dot}
          alt="dot"
          className="absolute hidden md:block top-[320px] right-[15%] w-4 h-4 z-10"
        />
        {/* Middle Left */}
        <img
          src={dot}
          alt="dot"
          className="absolute hidden md:block top-[440px] left-[15%] w-4 h-4 z-10"
        />
        {/* Middle Right */}
        <img
          src={dot}
          alt="dot"
          className="absolute hidden md:block top-[440px] right-[15%] w-4 h-4 z-10"
        />
        {/* Center Below Electronics */}
        <img
          src={dot}
          alt="center-dot"
          className="absolute hidden md:block top-[475px] left-1/2 -translate-x-1/2 w-4 h-4 z-10"
        />

        {/* Grid Layout */}
        <div className="mt-20 grid grid-cols-1 md:grid-cols-3 gap-14 items-start relative z-10">
          {/* Left Column */}
          <div className="flex flex-col gap-14 items-center md:items-end">
            <Card title="Automotive" />
            <Card title="Consumer Goods" />
          </div>

          {/* Center Column */}
          <div className="flex flex-col items-center top-[130px] justify-end relative mt-[-20px]">
            <Card title="Electronics" />
            <img
              src={handImage}
              alt="hand"   
              className="w-[150px] md:w-[180px]  object-contain absolute bottom-[0px] left-1/2 -translate-x-1/2 z-0"
            />
          </div>

          {/* Right Column */}
          <div className="flex flex-col gap-14 items-center md:items-start">
            <Card title="Aerospace" />
            <Card title="Healthcare & Medical Devices" />
          </div>
        </div>
      </div>
    </section>

  
    </>
   );
};

export default ManufactureHero;      